"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var SimulatedColumn_1 = require("../model/SimulatedColumn");

var SimulatedColumnConverter_1 = require("./SimulatedColumnConverter"); //tslint:disable:max-classes-per-file


var SimulatedColumnBigNumConverterImpl =
/*#__PURE__*/
function (_SimulatedColumnConve) {
  _inherits(SimulatedColumnBigNumConverterImpl, _SimulatedColumnConve);

  function SimulatedColumnBigNumConverterImpl() {
    _classCallCheck(this, SimulatedColumnBigNumConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulatedColumnBigNumConverterImpl).apply(this, arguments));
  }

  _createClass(SimulatedColumnBigNumConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SimulatedColumn_1.SimulatedColumnBigNum(source.value ? conversions.toBigNumber(source.value) : source.value, source.simulated, source.accepted ? source.accepted : null, source.note ? source.note : null);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        value: conversions.fromBigNumber(source.value),
        simulated: source.simulated,
        accepted: source.accepted ? source.accepted : null,
        note: source.note ? source.note : null
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "objectToArray",
    value: function objectToArray(instance, conversions) {
      var document = this.toDocument(instance, conversions);
      var arr = SimulatedColumn_1.SimulatedColumnBigNum.dataOrder.map(function (key) {
        return document[key];
      });
      return immutable_1.List(arr);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "arrayToObject",
    value: function arrayToObject(source, conversions) {
      var data = {};
      SimulatedColumn_1.SimulatedColumnBigNum.dataOrder.forEach(function (value, index) {
        if (typeof source[index] !== 'undefined') {
          data[value] = source[index];
        }
      });
      return this.toObject(data, conversions);
    }
  }]);

  return SimulatedColumnBigNumConverterImpl;
}(SimulatedColumnConverter_1.SimulatedColumnBigNumConverter);

exports.SimulatedColumnBigNumConverterImpl = SimulatedColumnBigNumConverterImpl;

var SimulatedColumnStringConverterImpl =
/*#__PURE__*/
function (_SimulatedColumnConve2) {
  _inherits(SimulatedColumnStringConverterImpl, _SimulatedColumnConve2);

  function SimulatedColumnStringConverterImpl() {
    _classCallCheck(this, SimulatedColumnStringConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SimulatedColumnStringConverterImpl).apply(this, arguments));
  }

  _createClass(SimulatedColumnStringConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SimulatedColumn_1.SimulatedColumnString(source.value, source.simulated, source.accepted ? source.accepted : null, source.note ? source.note : null);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        value: source.value,
        simulated: source.simulated,
        accepted: source.accepted ? source.accepted : null,
        note: source.note ? source.note : null
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "objectToArray",
    value: function objectToArray(instance, conversions) {
      var document = this.toDocument(instance, conversions);
      var arr = SimulatedColumn_1.SimulatedColumnString.dataOrder.map(function (key) {
        return document[key];
      });
      return immutable_1.List(arr);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "arrayToObject",
    value: function arrayToObject(source, conversions) {
      var data = {};
      SimulatedColumn_1.SimulatedColumnString.dataOrder.forEach(function (value, index) {
        if (typeof source[index] !== 'undefined') {
          data[value] = source[index];
        }
      });
      return this.toObject(data, conversions);
    }
  }]);

  return SimulatedColumnStringConverterImpl;
}(SimulatedColumnConverter_1.SimulatedColumnStringConverter);

exports.SimulatedColumnStringConverterImpl = SimulatedColumnStringConverterImpl;